import { useMemo } from 'react';
import type { ChatMessage, InstitutionCorrespondence } from '../../../types';
import {
  convertCorrespondenceToMessage,
  filterMessages,
  sortMessagesChronologically
} from '../utils/message-transform';

/**
 * Hook to transform correspondence to chat messages
 */
export function useMessageTransform(
  correspondence: InstitutionCorrespondence[],
  institutionName: string
) {
  const messages = useMemo(() => {
    // Exclude correspondence that was sent via post (external mail).
    // The draft content doesn't reflect what was actually sent externally.
    const digitalCorrespondence = correspondence.filter(
      (corr) => !corr.sentViaPost && !corr.sentViaPostAt
    );

    const chatMessages: ChatMessage[] = digitalCorrespondence.map((corr) =>
      convertCorrespondenceToMessage(corr, institutionName)
    );

    // Filter and sort messages
    const filtered = filterMessages(chatMessages);

    console.log('[useMessageTransform] Messages after filtering:', {
      beforeCount: chatMessages.length,
      afterCount: filtered.length,
      statuses: chatMessages.map((m) => m.status),
      filtered
    });

    return sortMessagesChronologically(filtered);
  }, [correspondence, institutionName]);

  // Count unread messages
  const unreadCount = useMemo(
    () => messages.filter((m) => !m.isRead && m.direction === 'inbound').length,
    [messages]
  );

  return { messages, unreadCount };
}
